export default "__VITE_ASSET__Bv2t6mpZ__"